import { useTranslation } from "react-i18next";
import { VariablesConstant } from "../../../../constants/variables";

interface DataMapProps {
  model?: any;
  dataMap?: any;
  handleChange: (event: any) => void;
  handleChangeDataMap: (event: any, index: any) => void;
  onAddRow?: () => void;
  onDeleteRow: (index: any) => void;
}

export default function DataMapInfo(props: DataMapProps) {
  const { t, i18n } = useTranslation();

  return (
    <>
      {props.model.connProtTp && (
        <div className="form-container">
          <div className="row align-items-center mb-3">
            <div className="col-lg-3 form-label-grid">
              <label className="form-label">
                {t("dcs0101.form.label.tableNm")}
                <strong className="strong-required"> *</strong>
              </label>
            </div>
            <div className="col-lg-9">
              <input value={props.model.tableNm || ""} type="text" className="form-control" name="tableNm" id="validationInput" onChange={props.handleChange} />
              <div className={`${props.model.tableNm?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.tableNm")}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
